export enum CarryOverType {
  // Call has no carry over data.
  None,

  // Voice carry over, one line.
  VCO1Line,

  // Voice carry over, two line.
  VCO2Line,
}
